import React from 'react'
import { Snackbar, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import MuiAlert from '@mui/material/Alert'
import {
  useGlobalStoreActions,
  useGlobalStoreState,
} from '../../store/globalStore'

interface IMySnackbarComponentProps {
  handleCloseSnackbar?: () => void
}

function Alert(props: any) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

const MySnackbarComponent = (props: IMySnackbarComponentProps) => {
  const snackbarMessageSeverity = useGlobalStoreState(
    state => state.snackbarMessageSeverity,
  )
  const snackbarMessage = useGlobalStoreState(state => state.snackbarMessage)
  const setSnackbarMessage = useGlobalStoreActions(
    actions => actions.setSnackbarMessage,
  )

  console.log('snackbarmessage2', snackbarMessage, snackbarMessageSeverity)

  function handleCloseSnackbar() {
    props.handleCloseSnackbar && props.handleCloseSnackbar()
    setSnackbarMessage('')
  }

  return (
    <Snackbar
      style={{ zIndex: 100000 }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      // style={{
      //   backgroundColor: "#f39631",
      //   color: "#fff",
      // }}
      open={Boolean(snackbarMessage)}
      autoHideDuration={3000}
      onClose={handleCloseSnackbar}
      // message={this.props.message}
      action={
        <span>
          {/* <Button color="secondary" size="small" onClick={this.handleCloseSnackbar}>
            UNDO
          </Button> */}
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={props.handleCloseSnackbar}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </span>
      }
    >
      <span>
        <Alert
          style={{ display: 'flex' }}
          onClose={props.handleCloseSnackbar}
          severity={snackbarMessageSeverity}
        >
          {snackbarMessage}
        </Alert>
      </span>
    </Snackbar>
  )
}

export default MySnackbarComponent
